// Migrated to Zustand - Phase 1: State Management Migration
import { useEnrichmentStore } from '../store/enrichmentStore';

export const useEnrichmentState = () => {
  const {
    enrichmentFrom,
    setEnrichmentFrom,
    clearEnrichmentFrom,
    pendingAdvancedSearchRedirect,
    setPendingAdvancedSearchRedirect,
    clearPendingAdvancedSearchRedirect,
    tableEnrichmentSelection,
    setTableEnrichmentSelection,
    clearTableEnrichmentSelection,
  } = useEnrichmentStore();

  return {
    enrichmentFrom,
    setEnrichmentFrom,
    clearEnrichmentFrom,
    pendingAdvancedSearchRedirect,
    setPendingAdvancedSearchRedirect,
    clearPendingAdvancedSearchRedirect,
    tableEnrichmentSelection,
    setTableEnrichmentSelection,
    clearTableEnrichmentSelection,
  };
};
